import { __exports as url } from './_virtual-url.js';
import { __require as requireUrl$1 } from './vp-js-token-engine-build-common-url.js';

var hasRequiredUrl;

function requireUrl () {
	if (hasRequiredUrl) return url;
	hasRequiredUrl = 1;

	Object.defineProperty(url, "__esModule", {
	  value: true
	});
	url.filter = filter;
	url.name = void 0;
	var _url = requireUrl$1();
	url.name = 'url';
	async function filter(pageId) {
	  let fullUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return await (0, _url.getUrl)(this, pageId, fullUrl);
	}
	
	return url;
}

export { requireUrl as __require };
//# sourceMappingURL=vp-js-token-engine-build-filters-url.js.map
